export default {
  女装: "Bayan giyimi",
  男装: "Erkeklerin",
  手机和小工具: "Cep telefonları ve gadget'lar",
  居家生活: "ev hayatı",
  电脑及周边设备: "Bilgisayarlar ve çevre birimleri",
  美容及个人护理: "Güzellik ve kişisel bakım",
  家用电器: "Ev aletleri",
  健康与保健: "sağlık ve sıhhat",
  食品和饮料: "yiyecek ve içecekler",
  玩具_儿童和婴儿: "oyuncaklar, çocuklar ve bebekler",
  童装时尚: "çocuk modası",
  视频游戏: "video oyunları",
  运动与户外: "Spor ve Açık Hava",
  爱好与书籍: "Hobiler ve kitaplar",
  相机和无人机: "Kameralar ve drone'lar",
  宠物食品及用品: "Evcil hayvan yemi ve malzemeleri",
  女士包袋: "kadın çantaları",
  男士包袋: "erkek çantaları",
  珠宝及配饰: "Takı ve Aksesuarlar",
  手表: "kol saati",
  女鞋: "kadın ayakkabıları",
  男装鞋: "erkek ayakkabıları",
  汽车: "araba",
  我附近的ShopeePay: "yakınımdaki ShopeePay",
  餐饮_旅行和服务: "Yemek, seyahat ve hizmetler",
  旅行及行李: "Seyahat ve bagaj",
  各种各样的: "Farklı türde",
  我是来买什么的: "Ne satın almak için buradayım?",
  对不起_找不到_相关的商品: "Üzgünüz, [{0}] ile ilgili ürün bulunamadı",
  类别: "kategori",
  产品: "ürün",
  店铺: "mağaza",
  首页: "ön Sayfa",
  限时秒杀: "Sınırlı süreli flaş indirim",
  博客: "Blog",
  所有品牌: "Tüm markalar",
  所有类别: "Tüm Kategoriler",
  我的购物车: "alışveriş sepetim",
  发货信息: "Teslimat Bilgisi",
  交货信息: "Teslimat Bilgisi",
  付款: "Ödeme",
  确认: "onaylamak",
  您的购物车是空的: "Alışveriş sepetiniz boş",
  价格: "fiyat",
  税: "Vergi",
  数量: "miktar",
  总计: "Toplam",
  移除: "Kaldırmak",
  返回商店: "Mağazaya dön",
  继续发货: "Göndermeye devam et",
  筛选: "filtre",
  价格范围: "fiyat aralığı",
  排序方式: "göre sırala",
  最新: "güncel",
  最旧: "en yaşlı",
  价格从低到高: "Düşükten yükseğe fiyatlar",
  价格从高到低: "Fiyat yüksekten düşüğe",
  选择交货类型: "Teslimat türünü seçin",
  送货上门: "Teslimat",
  继续付款: "Ödemeye devam et",
  任何其他信息: "diğer bilgiler",
  或者: "veya",
  您的钱包余额: "Cüzdan bakiyeniz",
  余额不足: "Yetersiz bakiye",
  支付: "ödemek",
  我同意: "Kabul ediyorum",
  条款和条件: "Şartlar ve koşullar",
  退货政策: "iade politikasi",
  隐私政策: "Gizlilik Politikası",
  概括: "genelleştirmek",
  项目: "proje",
  全部的: "Tümü",
  小计: "ara toplam",
  总运费: "toplam nakliye maliyeti",
  有优惠码吗_在这里输入: "İndirim kodu var mı? buraya girin",
  申请: "Uygula",
  编辑: "düzenlemek",
  删除: "silmek",
  添加新地址: "yeni adres ekleyin",
  继续交货信息: "Teslimat bilgilerine devam et",
  选择一个地址: "Bir adres seçin",
  购买历史: "Satın alım geçmişi",
  下载: "indirmek",
  已发送退款请求: "Geri ödeme isteği gönderildi",
  对比: "Karşılaştırıldı",
  对话: "diyalog",
  我的钱包: "Çantam",
  工单: "iş emri",
  管理个人资料: "Profili yönet",
  登出: "oturumu Kapat",
  重置对比列表: "Karşılaştırma listesini sıfırla",
  您的对比列表为空: "Karşılaştırma listeniz boş",
  在您的购物车中: "alışveriş sepetinizde",
  在您的愿望清单中: "istek listenizde",
  在您的预定列表中: "rezervasyon listenizde",
  下载您的产品: "Ürününüzü indirin",
  选项: "Seçenekler",
  什么都没找到: "Hiçbirşey Bulunamadı",
  特色产品: "Özel Ürünler",
  最畅销: "En çok satan kitap",
  前_名: "En iyi {0}",
  查看更多: "daha fazla gör",
  查看所有类别: "Tüm Kategoriler görüntüle",
  十大品牌: "İlk on marka",
  查看所有品牌: "Tüm markaları görüntüle",
  登录: "Giriş yapmak",
  手机号码: "telefon numarası",
  密码: "şifre",
  密码长度为6到16个字符: "Şifre uzunluğu 6 ila 16 karakter arasındadır",
  验证码: "Doğrulama kodu",
  登录中: "Giriş yapmak",
  游客登录: "Ziyaretçi girişi",
  注册您的商店: "Mağazanızı kaydedin",
  现在申请: "Şimdi Uygula",
  成为商家: "Tüccar ol",
  现在注册: "Şimdi üye Ol",
  登录成功: "Başarıyla indi",
  通知: "bildirmek",
  未找到通知: "bildirim bulunamadı",
  评论: "Yorum",
  估计运输时间: "Tahmini nakliye süresi",
  天: "gökyüzü",
  所售: "satılmış",
  给商家留言: "Satıcıya mesaj bırakın",
  规格: "Şartname",
  库存: "Stokta var",
  总价: "toplam fiyat",
  添加到购物车: "Sepete ekle",
  立即购买: "Şimdi satın al",
  缺货: "stoklar tükendi",
  添加到愿望清单: "İstek listesine ekle",
  加入对比列表: "Karşılaştırma listesine ekle",
  退款: "Geri ödemek",
  查看条款: "Şartları görüntüle",
  分享: "paylaşmak",
  描述: "betimlemek",
  相关产品: "ilgili ürünler",
  没有人问过商家: "Kimse tüccarlara sormadı",
  该产品暂无评论: "Bu ürün için henüz yorum yapılmamış",
  客户评论: "Musteri degerlendirmeleri",
  访问商店: "mağazayı ziyaret et",
  畅销产品: "En çok satanlar",
  日期: "tarih",
  订单编号: "sipariş numarası",
  总额: "Toptan",
  状态: "durum",
  愿望清单: "istek listesi",
  还没有添加任何东西: "Henüz hiçbir şey eklenmedi",
  注册: "kayıt olmak",
  邀请码: "Davet Kodu",
  请输入邀请码: "Lütfen davet kodunu girin",
  用户名: "Kullanıcı adı",
  请输入用户名: "lütfen kullanıcı adını girin",
  用户名长度为6_14个字符: "Kullanıcı adı uzunluğu 6-14 karakterdir",
  昵称: "Takma ad",
  请输入手机号码: "Lütfen telefon numarasını girin",
  手机号码格式错误: "Telefon numarasının yanlış formatı",
  密码长度为6_16个字符: "Şifre uzunluğu 6-16 karakterdir",
  确认密码: "Şifreyi Onayla",
  请输入确认密码: "Lütfen onay şifresini girin",
  提款密码: "Para çekme şifresi",
  请输入提款密码: "Lütfen para çekme şifresini girin",
  提款密码长度为4_16个字符: "Para çekme şifresi uzunluğu 4-16 karakterdir",
  请输入验证码: "lütfen doğrulama kodunu girin",
  在_s后发送: "{0} saniye sonra gönderildi",
  发送验证码: "Doğrulama kodunu gönder",
  注册即表示您同意我们的条款和条件:
    "Kaydolarak şartlar ve koşullarımızı kabul etmiş olursunuz.",
  创建账号: "Bir hesap oluşturun",
  验证码发送成功: "Doğrulama kodu başarıyla gönderildi",
  确认密码不一致: "Şifrenin tutarsız olduğunu doğrulayın",
  提款密码必须为数字: "Para çekme şifresi sayısal olmalıdır",
  注册成功: "başarılı Kayıt",
  购物车: "alışveriş Sepeti",
  账户: "Hesap",
  我的账户: "hesabım",
  已经有一个账户: "Zaten hesabınız var mı",
  新地址: "yeni adres",
  编辑地址: "Adresi düzelt",
  保存: "kaydetmek",
  是否默认: "Varsayılan mı",
  具体地址: "Özel adres",
  请输入具体地址: "Lütfen spesifik bir adres girin",
  地区: "alan",
  请输入地区: "Lütfen bölgeyi girin",
  城市: "Şehir",
  请输入城市: "Lütfen şehri girin",
  省份: "vilayet",
  请输入省份: "Lütfen ili girin",
  邮政编码: "Posta Kodu",
  请输入邮政编码: "Lütfen posta kodunu girin",
  电话号码: "telefon numarası",
  请输入电话号码: "Lütfen telefon numaranızı girin",
  收货人: "Alıcı",
  请输入收货人: "Lütfen alıcıyı girin",
  保存成功: "Başarıyla kaydedildi",
  最畅销的商家: "En Çok Satan Tüccarlar",
  查看所有的商家: "Tüm işletmeleri görüntüle",
  支持政策: "Destek politikası",
  您的电子邮件地址: "E-posta adresiniz",
  订阅: "abonelik",
  联系方式: "İletişim bilgileri",
  地址: "adres",
  美国伊利诺伊州霍夫曼庄园: "Hoffman Estates, Illinois, ABD",
  快速链接: "Hızlı Linkler",
  商家政策: "Satıcı politikaları",
  submit: "göndermek",
  提款银行卡: "Banka kartından para çekme",
  我的面板: "benim panelim",
  提示: "ipucu",
  确定登出吗: "Oturumu kapatmak istediğinizden emin misiniz?",
  确定: "Elbette",
  取消: "İptal etmek",
  项目添加到您的购物车: "Ürünü alışveriş sepetinize ekleyin",
  经常一起购买: "sıklıkla birlikte satın alırız",
  返回购物: "Alışverişe dön",
  进行结算: "çıkışa doğru devam et",
  帮助热线: "Yardım Hattı",
  查看所有通知: "Tüm bildirimleri görüntüle",
  请输入密码: "Lütfen şifre giriniz",
  前往充值: "Şarj etmeye git",
  购物车物品: "Alışveriş sepeti öğeleri",
  查看购物车: "alışveriş sepetini kontrol et",
  钱包余额: "cüzdan bakiyesi",
  充值钱包: "Cüzdanı yeniden şarj edin",
  钱包充值_线下_: "Cüzdan yüklemesi (çevrimdışı)",
  申请提款: "Para çekme başvurusu",
  钱包收支明细: "Cüzdan Gelir ve Harcama Detayları",
  批准: "onaylamak",
  提现历史记录: "Para çekme geçmişi",
  类型: "tip",
  信息: "bilgi",
  付款方式: "ödeme yöntemi",
  请选择付款方式: "Lütfen bir ödeme yöntemi seçin",
  Bill_Type_RECHARGE_BACK: "Arka uç şarjı",
  Bill_Type_RECHARGE_ONLINE: "Çevrimiçi şarj",
  Bill_Type_RECHARGE_REGISTER: "Ücretsiz kayıt olun",
  Bill_Type_RECHARGE_JACKPOT: "Yeniden yükleme bonusu",
  Bill_Type_RECHARGE_PRESENT: "Ödülleri yeniden yükle",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Komisyon transferi",
  Bill_Type_RECHARGE_TG_COMMISSION: "Promosyon komisyonunu yeniden şarj edin",
  Bill_Type_REGISTER_TG_COMMISSION: "Kayıt tanıtım komisyonu",
  Bill_Type_WITHDRAW: "geri çekilmek",
  Bill_Type_WITHDRAW_REJECT: "Para çekme reddedildi",
  Bill_Type_DEDUCT_HANDLE: "Manuel kesinti",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Şarj düzeltmesi",
  Bill_Type_MINING_PROFIT: "Madencilik geliri",
  Bill_Type_MINING_PROFIT_COMMISSION: "Madencilik geliri teşvik komisyonu",
  Bill_Type_VIP_UPGRADE: "VIP'yi yükselt",
  Bill_Type_FINANCE_BUY: "Finansal ürünler satın alın",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Mali dengenin geri dönüşü",
  Bill_Type_FINANCE_FEE: "Finansal yönetim ücretleri",
  Bill_Type_FINANCE_PROFIT: "Finansal yönetim geliri",
  Bill_Type_FINANCE_BUY_COMMISSION: "Finansal ürünleri satın alma komisyonu",
  Bill_Type_FINANCE_PROFIT_COMMISSION: "Finansal ürün gelir komisyonu",
  Bill_Type_WHEEL_DRAW: "Büyük çarklı piyango",
  Bill_Type_BUY: "mal satın al",
  Bill_Type_PAY_SHOP: "Nakliye için ödeme yapın",
  Bill_Type_BUY_COMMISSION: "Satın alınan ürünlerden komisyon",
  Bill_Type_DEPOSIT: "Depozito öde",
  Bill_Type_STORE_BUY: "mal satın al",
  Bill_Type_STORE_BUY_REFUND: "Ürün iadesi satın alın",
  Bill_Type: "Hesap değişikliği türü",
  Before_Money: "önceki miktar",
  Deal_Money: "Hesap değişiklik tutarı",
  After_Money: "Sonraki miktar",
  Bill_Time: "Hesap değiştirme zamanı",
  No_More_Data: "daha fazla veri yok",
  Apply_Money: "Başvuru Tutarı",
  Apply_Time: "başvuru zamanı",
  Withdraw_Info: "İşleme ücreti: {fee}, varış: {money}",
  提款订单状态_CHECKING: "Bekleyen yorum",
  提款订单状态_TRANSFERRING: "Aktarılıyor",
  提款订单状态_PASS: "onaylanmış",
  提款订单状态_REJECT: "İşten",
  暂无可用充值方式: "Henüz bir şarj yöntemi mevcut değil",
  钱包收款码: "Cüzdan ödeme kodu",
  钱包地址: "cüzdan adresi",
  金额限制: "Tutar sınırı",
  复制: "kopyala",
  付款凭证: "ödeme kuponu",
  收款银行: "Yararlanıcı Bankası",
  收款人: "Alacaklı",
  收款账号: "Ödeme hesap numarası",
  付款银行: "ödeme bankası",
  付款人: "Ödeyen",
  付款账号: "Ödeme Hesabı",
  请输入付款银行: "Lütfen ödeme bankasını girin",
  请输入付款人: "Lütfen ödeyeni girin",
  请输入付款账号: "Lütfen ödeme hesap numarasını girin",
  请上传付款凭证: "Lütfen ödeme makbuzunu yükleyin",
  充值金额: "Yeniden yükleme miktarı",
  请输入充值金额: "Lütfen yükleme tutarını girin",
  submitting: "gönderiliyor...",
  Confirm: "göndermek",
  Commit_Success: "Başarıyla gönderildi",
  balanceType_BALANCE: "denge",
  balanceType_COMMISSION: "komisyon",
  Balance: "Hesap bakiyesi",
  Wash_Money: "mozaik ekle",
  请选择银行账户: "Lütfen bir banka hesabı seçin",
  卡号类型: "Kart numarası türü",
  提现金额: "Para Çekme Tutarı",
  提款金额: "Para çekme tutarı",
  不能为空: "Boş olamaz",
  金额不正确: "Tutar yanlış",
  please_input_withdraw_password: "Lütfen para çekme şifresini girin",
  withdraw_password_format_error:
    "Para çekme şifresi 4-16 karakterden oluşmalıdır",
  Fee: "Hizmet bedeli",
  实际到账: "Gerçek varış",
  交易币种: "İşlem para birimi",
  原始密码: "orijinal şifre",
  confirm_password_error: "İki kez girilen şifre yanlış",
  save_success: "Başarıyla kaydedildi",
  please_input: "girin lütfen",
  old_password: "eski Şifre",
  new_password: "Yeni Şifre",
  please_input_confirm_password: "Lütfen şifreyi tekrar onaylayın",
  没有找到符合条件的商品: "Eşleşen ürün bulunamadı",
  Search: "aramak",
  全部: "Tümü",
  EnumGoodsOrderState_USER_PAY: "Teslimat bekleniyor",
  EnumGoodsOrderState_SHOP_PAY: "Teslim",
  EnumGoodsOrderState_SUCCESS: "Sona ermek",
  EnumGoodsOrderState_CANCEL: "İptal edildi",
  EnumGoodsOrderState_REFUND_SUCCESS: "iade edildi",
  订单号: "sipariş numarası",
  用户名称: "Kullanıcı adı",
  收益: "gelir",
  支付时间: "Ödeme süresi",
  配送时间: "Teslimat süresi",
  完成时间: "Tamamlama süresi",
  发货: "Gemi",
  全选: "hepsini seç",
  物品已添加到愿望清单: "Öğe istek listesine eklendi",
  物品已添加到比较列表: "Ürün karşılaştırma listesine eklendi",
  购买成功提示: "Tebrikler, satın alma işleminiz başarıyla tamamlandı",
  订单列表: "Sipariş listesi",
  商品名: "Ürün adı",
  图片: "resim",
  没有品牌: "marka yok",
  基本信息: "Temel Bilgiler",
  Account_Name: "Hesap açılış adı",
  Bank_Account: "Banka hesabı",
  Bank_Phone: "Cep telefonu numarasını rezerve et",
  IFSC: "IFSC hesabı",
  UPI: "UPI hesabı",
  PIX: "PIX hesabı",
  CPF: "CPF hesabı",
  GCASH: "GCASH hesabı",
  POWWI: "POWWI hesabı",
  身份证号: "kimlik Numarası",
  Edit: "Tekrar düzeltme yapmak",
  Delete: "silmek",
  Add: "Yeni",
  Forget_Withdraw_Password: "Para çekme şifresini unuttum",
  Bank_Card_Info: "Banka kartı bilgileri",
  收款人地址: "Alacaklı Adresi",
  SWIFT: "SÜRATLİ",
  Bank_Branch: "Şube adı",
  分行代码: "Şube Kodu",
  银行地址: "banka adresi",
  Email: "E-posta",
  银行卡长度必须超过: "Banka kartının uzunluğu {length} değerini aşmalıdır",
  银行卡格式不正确: "Banka kartı formatı yanlış",
  Do_you_confirm_delete: "Silmeyi onayla?",
  Please_Login_First: "lütfen önce giriş yapın",
  Bank_Name: "banka adı",
  Please_add_bank_first:
    "Henüz banka kartınızı bağlamadınız, lütfen önce ekleyin",
  withdrawType: "Para çekme türü",
  withdraw_money_limit:
    "Para çekme tutarı 0'dan büyük ve {balance}'a eşit veya küçük olmalıdır",
  withdraw_times_limit:
    "Bugün {todayWithdrawNum} defa para çektiniz ve {limitTimes} defadan sonra %{withdrawFee} tutarında işlem ücreti tahsil edilecektir. Geri çekileceğinizden emin misiniz?",
  Copy_Success: "Başarıyla kopyalandı",
  商店首页: "Mağaza ana sayfası",
  所有产品: "Tüm ürünler",
  新到货产品: "Yeni gelen ürünler",
  所有商家: "Tüm satıcılar",
  请上传: "Lütfen yükleyin",
  请输入: "girin lütfen",
  忘记密码: "şifreyi unut",
  记得我: "Beni hatırla",
  共_件: "Toplam {0} öğe",
  取消订单: "siparişi iptal et",
  申请退款: "Geri ödeme isteğinde bulunun",
  未知商家: "Bilinmeyen satıcı",
  到账: "Fiş",
  提款订单状态: "Para çekme emri durumu",
  前_名类别: "En iyi {0} kategori",
  取消订单原因_不想要了: "Artık istemiyorum",
  取消订单原因_商品错选_多选: "Yanlış ürün seçimi/çoklu seçim",
  取消订单原因_商品无货: "Ürün stokta yok",
  取消订单原因_地址信息填写错误: "Adres bilgileri hatalı girildi",
  取消订单原因_商品降价: "Ürün fiyat indirimi",
  取消订单原因_价格高于其他平台: "Fiyatı diğer platformlara göre daha yüksek",
  取消订单原因_没用_少用_错用优惠:
    "İndirimlerin kullanılmaması/az kullanılması/yanlış kullanılması",
  退款原因_拍错_多拍_不喜欢: "Yanlış atış / fazladan atış / beğenmedim",
  退款原因_商品成分描述不符: "Ürün içerik açıklaması eşleşmiyor",
  退款原因_与商家协商一致退款:
    "Satıcıyla mutabakata varıldığı şekilde geri ödeme",
  退款原因_生产日期_保质期与商品描述不符:
    "Üretim tarihi/raf ömrü ürün açıklamasıyla eşleşmiyor",
  退款原因_图片_产地_批号_规格等描述不符:
    "Resimler/menşe menşei/parti numarası/özellikler ve diğer açıklamalar eşleşmiyor",
  退款原因_质量问题: "Kalite sorunları",
  退款原因_商品变质_发霉_有异物: "Ürün bozulmuş/küflü/yabancı madde içeriyor",
  退款原因_少件_含缺少配件_: "Az sayıda parça (eksik aksesuarlar dahil)",
  退款原因_收到商品时有破损_污渍_变形:
    "Ürün teslim alındığında hasar görmüş/lekeli/deforme olmuş.",
  退款原因_假冒品牌: "Sahte markalar",
  退款原因_发票问题: "Fatura sorunları",
  退款原因_商家发错货: "Satıcı yanlış mal gönderdi",
  退款原因_预约不到_商家不给退换:
    "Randevu alamıyorum/satıcı size para iadesi veya değişim yapmıyor",
  退款失败: "Geri ödeme başarısız oldu",
  退款处理中: "Geri ödeme işlemi devam ediyor",
  默认: "varsayılan",
  产品查询: "Ürün Arama",
  商店LOGO: "LOGO'yu saklayın",
  推广码: "Promosyon kodu",
  查看所有: "hepsini gör",
  确认收货成功: "Malların alındığını başarıyla onaylayın",
  物流公司: "Lojistik şirket",
  物流单号: "gönderi numarası",
  发货时间: "Dağıtım zamanı",
  请先选择商品规格: "Lütfen önce ürün özelliklerini seçin",
  个人信息: "kişisel bilgi",
  您的用户名: "Kullanıcı adınızı",
  你的名字: "Adınız",
  登录名: "Kullanıcı adı",
  你的邮件: "E-posta adresiniz",
  你的密码: "şifreniz",
  重复输入密码: "Şifreyi tekrar girin",
  店铺名称: "Dükkan adı",
  证书类型: "Sertifika Türü",
  身份证: "kimlik kartı",
  护照: "pasaport",
  驾驶执照: "Ehliyet",
  社会保障卡: "Sosyal Güvenlik kartı",
  证书正面: "Sertifika ön yüzü",
  证书反面: "Sertifika arka tarafı",
  确认收货: "malların alındığını onaylamak",
  请选择取消订单的原因必选:
    "Lütfen siparişi iptal etme nedenini seçin (gerekli):",
  请选择申请退款的原因必选:
    "Lütfen geri ödeme isteğinizin nedenini seçin (gerekli):",
  留言: "İleti",
  请输入留言: "Lütfen bir mesaj girin",
  没有帐户: "Hesap yok",
  钱包充值: "Cüzdan yüklemesi",
  输入您的文字: "Metninizi girin",
  商家登录: "Satıcı girişi",
  有关此产品的任何查询: "Bu ürünle ilgili herhangi bir sorunuz",
  产品名称: "Ürün adı",
  你的问题: "senin sorunun",
  白银店铺: "gümüş dükkanı",
  铂金店铺: "platin mağazası",
  钻石店铺: "elmas dükkanı",
  照片: "Fotoğraf",
  已退货: "İade",
  邮寄状态: "Posta durumu",
  订单摘要: "Sipariş özeti",
  收件地址: "Alıcı adresi",
  订购日期: "Sipariş tarihi",
  订单状态: "Sipariş durumu",
  总订单金额: "Toplam sipariş tutarı",
  邮寄方式: "Posta yöntemi",
  附加信息: "Ek Bilgiler",
  订单详细信息: "Sipariş detayları",
  交货类型: "Teslimat türü",
  进行评论: "Bir yorum yap",
  已评论: "Yorum yapıldı",
  订单金额: "sipariş miktarı",
  优惠券: "kupon",
  统一运费: "Sabit nakliye ücreti",
  送货地址: "Gönderi Adresi",
  评分: "Gol",
  你的意见: "senin görüşün",
  匿名: "anonim",
  现金: "peşin",
  详情: "Detaylar",
  收货地址: "Gönderi Adresi",
  暂时没有对话: "Henüz konuşma yok",
  你: "Sen",
  输入您的回复: "Cevabınızı girin",
  删除成功: "başarıyla silindi",
  品牌: "marka",
  已缴纳的保证金: "Güvenlik depozitosu ödendi",
  黄金店铺: "altın deposu",
  没有更多数据: "daha fazla veri yok",
  站内信: "Site mesajı",
  系统通知: "sistem bildirimi",
  邮箱: "Posta",
  手机号: "Telefon numarası",
  你的手机号: "telefon numaran",
  营业执照: "işletme lisansı",
  你的邮箱: "posta kutunuz",
  搜索结果: "Arama Sonuçları",
  系统公告: "sistem bildirimi",
  客服: "müşteri servisi",
  消息已撤回: "Mesaj geri çekildi",
  物流详情: "Lojistik ayrıntıları",
  充值: "tamamlamak",
  提现: "geri çekilmek",
  信用分: "kredi notu",
  余额: "denge",
  佣金: "komisyon",
  继续购物: "alışverişe devam",
  订单结算: "Sipariş yerleşimi",
  加入对比: "Karşılaştırmaya ekle",
  佣金余额: "Komisyon bakiyesi",
  刷新: "yenileme",
  刷新成功: "Yenileme başarılı",
  官网: "Resmi internet sitesi",
  税号: "Vergi Kimlik Numarası",
  订单: "Emir",
  合计: "Toplam",
  系统安全: "Sistem güvenliği",
  Recharge_Money_Limit:
    "Yeniden yükleme miktarı {min} ile {max} arasında olmalıdır",
  限时优惠: "Sınırlı süreli teklif",
  高价回收: "Yüksek fiyatlı geri dönüşüm",
  姓名: "İsim",
  商品订单号: "Ürün sipariş numarası",
  商品在线回收: "Ürün çevrimiçi geri dönüşümü",
  提交: "göndermek",
  回收记录: "Geri dönüşüm kayıtları",
  回收状态: "Geri dönüşüm durumu",
  回收价格: "geri dönüşüm fiyatı",
  纳税码: "vergi kodu",
  买家登录: "Giriş yapmak",
  买家注册: "kayıt olmak",
  language: "土耳其",
  助力提示:
    "Tüccarlara yardım etmek platformun mağazalarına maruz kalmasını artırabilir ve kümülatif gün sayısı ne kadar yüksek olursa, maruz kalma o kadar yüksek olur.",
  已累计助力: "Kümülatif olarak destekli",
  今日已助力: "Bugün yardımcı oldu",
  立即助力: "Hemen Yardım Edin",
  商家助力: "Tüccar Yardımı",
  证件号码: "Kimlik numarası",
  证书号码: "Sertifika numarası",
  男鞋: "Erkek ayakkabıları",
  游戏玩具: "Oyun oyuncakları",
  使用条款: "Kullanım Koşulları",
  商家: "Tüccar",
  已助力: "Yardımcı oldu",
  被助力: "Yardım",
  用户: "kullanıcı",
  助力记录: "Kayıt Yardım",
  消息类型: "Mesaj türü",
  消息内容: "Mesaj İçeriği",
  链接: "Bağlantı",
  文本: "metin",
  清空: "Temizlemek",
  评论成功: "Yorum başarılı",
  扫描二维码: "QR kodunu tarayın",
  转入: "transfer etmek",
  收款: "Koleksiyon",
  任务下单中心: "Görev emri merkezi",
  记录: "kayıt",
  任务倒计时: "Görev geri sayımı",
  倒计时后自动放弃: "Geri sayımdan sonra otomatik olarak pes et",
  业务码: "İşletme kodu",
  选择商品分类: "Ürün kategorisini seçin",
  可多选: "Çoklu seçim mümkün",
  加载分类中: "Kategoriler yükleniyor",
  暂无分类: "Henüz sınıflandırma yok",
  产品类别: "Ürün Kategorisi",
  账户余额: "Hesap bakiyesi",
  立即结算: "Derhal uzlaşma",
  任务已自动放弃: "Görev otomatik olarak terk edildi",
  商品分类: "Ürün sınıflandırması",
  订单详情: "Sipariş ayrıntıları",
  预计收益: "Tahmini gelir",
  预计佣金收益: "Tahmini komisyon geliri",
  收益率: "Verim",
  扣款账户: "Banka hesabı",
  确认结算: "Ödemeyi onayla",
  未选择: "Seçilmedi",
  请选择商品分类: "Lütfen bir ürün kategorisi seçin",
  下单成功: "Sipariş başarıyla verildi",
  下单失败: "Sipariş başarısız oldu",
  请重试: "Lütfen tekrar deneyin",
  订单记录: "Sipariş kaydı",
  没有更多了: "artık yok",
  业务号: "İşletme numarası",
  商品类型: "Ürün türü",
  佣金收益: "komisyon geliri",
  待结算: "Anlaşma bekleniyor",
  已结算: "Yerleşik",
  已取消: "İptal edildi",
  加载失败: "Yükleme başarısız oldu",
  倒计时: "Geri sayım",
  随机商品: "rastgele öğeler",
  为: "için",
  商户助力可提升商品曝光度: "Satıcı yardımı ürünün görünürlüğünü artırabilir",
  累计助力越高推荐权重越高:
    "Birikmiş yardım ne kadar yüksek olursa öneri ağırlığı da o kadar yüksek olur.",
  实时助力动态: "Gerçek zamanlı yardım dinamikleri",
  助力奖励: "Ödülleri artırın",
  随机奖励金额已生成: "Rastgele ödül miktarı oluşturuldu",
  开心收下: "Kabul etmekten mutluyum",
  助力已结束: "Yardım sona erdi",
  助力成功: "Başarıya yardımcı olun",
  成功: "başarı",
  进行中: "Devam ediyor",
  等待: "bekle",
  助力失败: "Yardım başarısız oldu",
  任務: "Görev",
  下单失败_请稍后重试:
    "Sipariş başarısız oldu, lütfen daha sonra tekrar deneyin",
  任务: "Görev"
};
